import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Home, Phone, Search, Music } from "lucide-react";
import { Button } from "@/components/ui/button";
import AnimatedSection from "@/components/ui/animated-section";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  const suggestedLinks = [
    { label: "Home", path: "/", icon: Home },
    { label: "Artists", path: "/artists", icon: Music },
    { label: "Services", path: "/services", icon: Search },
    { label: "Contact Us", path: "/contact", icon: Phone },
  ];

  return (
    <div className="min-h-screen bg-background relative overflow-hidden flex items-center justify-center px-4">
      <div className="max-w-lg w-full text-center relative z-10">
        <AnimatedSection animation="fade-up">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-accent/10 rounded-[4px] mb-8 border border-accent/20">
            <span className="text-sm font-semibold text-accent uppercase tracking-[0.08em]">Page Not Found</span>
          </div>

          <div className="relative mb-8">
            <h1 className="text-[150px] md:text-[200px] font-heading font-black text-foreground/5 leading-none select-none">
              404
            </h1>
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="text-accent text-6xl md:text-8xl font-heading font-bold">Oops!</span>
            </div>
          </div>

          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground mb-4">
            This Page Wandered Off
          </h2>
          <p className="text-muted-foreground mb-8 max-w-md mx-auto">
            The page you're looking for doesn't exist or has been moved. Let's get you back on track.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Button size="lg" asChild>
              <Link to="/">
                <Home className="mr-2 h-4 w-4" />
                Back to Home
              </Link>
            </Button>
            <Button size="lg" variant="outline" asChild>
              <Link to="/contact">
                <Phone className="mr-2 h-4 w-4" />
                Contact Support
              </Link>
            </Button>
          </div>

          <div className="border-t border-divider pt-8">
            <p className="text-sm text-muted-foreground mb-4 uppercase tracking-[0.08em] font-medium">
              Popular pages you might be looking for
            </p>
            <div className="flex flex-wrap justify-center gap-3">
              {suggestedLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="group inline-flex items-center gap-2 px-4 py-2.5 rounded-[4px] border border-divider text-foreground text-sm hover:border-accent/30 hover:text-accent transition-all duration-300"
                >
                  <link.icon className="h-4 w-4" />
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </AnimatedSection>
      </div>
    </div>
  );
};

export default NotFound;
